const {
  // Endpoints
  VITE_BASE_URL: BASE_URL,
  // Auth
  VITE_TOKEN_BASE_URL: TOKEN_BASE_URL,
  VITE_REFRESH_TOKEN_URL: REFRESH_TOKEN_URL,
  VITE_AUTHORIZE_BASE_URL: AUTHORIZE_BASE_URL,
  VITE_LOGOUT_BASE_URL: LOGOUT_BASE_URL,
  VITE_API_KEY: API_KEY,
  VITE_CLIENT_ID: CLIENT_ID,
  VITE_SCOPE: SCOPE,
  VITE_ANALYTICS_ID: ANALYTICS_ID,
  VITE_AUTHORIZATION_KEY: AUTHORIZATION_KEY,
} = import.meta.env;

// const BASE_URL_V2 = BASE_URL.replace("/v1", "/v2");
const API_V1_URL = "/api/v1";
const API_V2_URL = "/api/v2";

export {
  BASE_URL,
  // BASE_URL_V2,
  API_V1_URL,
  API_V2_URL,
  TOKEN_BASE_URL,
  REFRESH_TOKEN_URL,
  AUTHORIZE_BASE_URL,
  LOGOUT_BASE_URL,
  API_KEY,
  CLIENT_ID,
  SCOPE,
  ANALYTICS_ID,
  AUTHORIZATION_KEY,
};
